interface ILandingPageActionsProps {
  children?: React.ReactNode;
}
export function LandingPageActions(props: Readonly<ILandingPageActionsProps>) {
  const { children } = props;

  return (
    <div className="landing-page-actions">
      <div className="avis-row">{children}</div>
    </div>
  );
}
